// ─── Il registro attività ────────────────────────────────────────────────────
import { z } from 'zod';
export const rigaRegistroSchema = z.object({
    id: z.string(),
    at: z.string(),
    actorUserId: z.uuid().nullable(),
    /** Nullo per le azioni di sistema: travaso, migrazioni, consegnatore. */
    actorEmail: z.string().nullable(),
    action: z.string(),
    entityType: z.string().nullable(),
    entityId: z.string().nullable(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    requestId: z.string().nullable(),
});
export const filtroRegistroSchema = z.object({
    from: z.iso.datetime().optional(),
    to: z.iso.datetime().optional(),
    actor: z.uuid().optional(),
    action: z.string().max(100).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    /** Il cursore è l'`id` dell'ultima riga vista: le righe sono in ordine di id. */
    cursor: z.string().optional(),
});
export const paginaRegistroSchema = z.object({
    items: z.array(rigaRegistroSchema),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=registro.js.map